module.exports = __webpack_public_path__ + "media/images/hero_images/index-3000-84d42976396753a57a3367d1a32fef65.jpg";